import React from "react";
import UIDefaultPage from "../../components/UIDefaultPage";
import PutAwayForm from "./components/putAway/PutAwayForm";

function PutAway() {
  return <UIDefaultPage title={"Put Away"} children={<PutAwayForm />} />;
}

export default PutAway;
